import { render, staticRenderFns } from "./SortingFilter.vue?vue&type=template&id=28914080&scoped=true&"
import script from "./SortingFilter.vue?vue&type=script&lang=js&"
export * from "./SortingFilter.vue?vue&type=script&lang=js&"
import style0 from "./SortingFilter.vue?vue&type=style&index=0&id=28914080&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28914080",
  null
  
)

export default component.exports